import React from 'react';
import Breadcrumb from '../../Breadcrumb/Breadcrumb';
import LearningPlansIndexCard from '../../LearningPlans/LearningPlansIndexCard';

export default function LearningPlansPage(props) {
	// console.log('LearningPlansPage', props);
	return (
		<div>
			<Breadcrumb
				pageName={I18n.t('admin.learning_plans')}
				category={I18n.t('admin.learning_plans')}
			/>
			<LearningPlansIndexCard
				permissionsHelper={props.permissionsHelper}
				public_id={props.public_id}
				learning_plan_create_endpoint={props.learning_plan_create_endpoint}
				get_learning_plan_endpoint={props.get_learning_plan_endpoint}
				update_learning_plan_endpoint={props.update_learning_plan_endpoint}
				delete_learning_plan_endpoint={props.delete_learning_plan_endpoint}
				learning_plans_list_endpoint={props.learning_plans_list_endpoint}
			/>
		</div>
	);
}
